import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { subscribe, unsubscribe } from '../core/decorators';



/**
 * Every component that uses `@BindAction` must extends from this
 * class in order to make sure that AOT won't delete OnInit and
 * OnDestroy life-cycle events used by the decorator, irrespective
 * of the fact that it may or may not be used by the component itself
 *
 * @export
 * @class DataObserver
 * @implements {OnInit}
 * @implements {OnDestroy}
 */

export abstract class DataObserver
{
    constructor() {}

    init()
    {
        // empty on purpose
        subscribe.bind(this)();
    }

    destroy()
    {
        // empty on purpose
        unsubscribe.bind(this)();
    }
}
